import React from "react";
import { MuiX } from "@osu/react-ui";
import { isValid } from "date-fns";
import { getLocalDateForTimeZone } from "../../../../util/functions";

const DatePicker = (props = {}) => {
  const { onChange, ...rest } = props;
  const displayValue = (props?.value ? getLocalDateForTimeZone(props.value) : props?.value);
  const onDateChange = (value) => {
    if(isValid(value) || value === null) {
      onChange(value);
    }
  };
  return (<MuiX.DatePicker {...rest} value={displayValue} onChange={onDateChange} />);
};
  
export default DatePicker